<template>
    <div class="banner_wrap">
        <div class="title_btn">添加场景</div>

        <div class="case_wrap">
            <div class="item">
                <div class="case-item">
                    <span class="label">*排列序号</span>
                    <el-input-number v-model="scenarios_item.sort" :min="1" clearable class="name-input" placeholder="请输入排列序号" style="width: 300px;" /></el-input-number>
                </div>

                <div class="case-item">
                    <span class="label co_w">*场景名称</span>
                    <el-input v-model="scenarios_item.title" clearable class="name-input" placeholder="请输入解决方案名称" />
                </div>
            </div>

            <div class="item">
                <div class="case-item">
                    <span class="label">*以前</span>
                    <el-input v-model="scenarios_item.old_content" type="textarea" :autosize="{ minRows: 6, minCols:60}" clearable class="name-input" placeholder="请输入文字描述" />
                </div>

                <div class="case-item">
                    <span class="label co_w">*以前-图片</span>
                    <div>
                        <imageUpload v-model="scenarios_item.oldImg" :limit="1" />
                        <el-input v-model="scenarios_item.old_img_alt" clearable class="alt-input" placeholder="请输入自定义ALT（选填）" />
                    </div>
                </div>
            </div>

            <div class="item">
                <div class="case-item">
                    <span class="label">*现在</span>
                    <el-input v-model="scenarios_item.new_content" type="textarea" :autosize="{ minRows: 6, minCols:60}" clearable class="name-input" placeholder="请输入文字描述" />
                </div>

                <div class="case-item">
                    <span class="label co_w">*现在-图片</span>
                    <div>
                        <imageUpload v-model="scenarios_item.newImg" :limit="1" />
                        <el-input v-model="scenarios_item.new_img_alt" clearable class="alt-input" placeholder="请输入自定义ALT（选填）" />
                    </div>
                </div>
            </div>
        </div>

        <div class="btn_wrap">
            <el-button type="primary" @click="addScene">确定</el-button>
            <el-button type="primary" plain @click="$router.go(-1);">取消</el-button>
        </div>
    </div>
</template>
<script>
import baseURL from '@/configs/baseUrl';
import utils from '@/jslibs/utils';
import { imgDomain } from '@/configs/env';
import imageUpload from '@/components/ImageUpload';
export default {
    components: {
        imageUpload
    },
    data() {
        return {
            imgDomain,
            headers: {
                'X-Access-Token': utils.getCookie('X-Access-Token') || ''
            },
            baseURL,
            scenceList: [],
            scenarios_item: {
                sort: "",
                title: "",
                old_content: "",
                new_content: "",
                old_img: "",
                oldImg: [],
                old_img_alt: "",
                new_img: "",
                newImg: [],
                new_img_alt: ""
            }
        };
    },

    created() {
        const scenceList = sessionStorage.getItem("scenceList");
        if (scenceList) {
            this.scenceList = JSON.parse(scenceList) ? JSON.parse(scenceList) : [];
        }
    },

    methods: {
        addScene() {
            const { sort, title, old_content, oldImg, old_img_alt, new_content, newImg, new_img_alt } = this.scenarios_item;
            if (!sort) {
                this.$notify.error({ title: '请输入名称排序' });
                return false
            }
            if (!title) {
                this.$notify.error({ title: '请输入场景名称' });
                return false
            }
            if (!old_content) {
                this.$notify.error({ title: '请输入以前场景文字描述' });
                return false
            }
            if (!oldImg.length) {
                this.$notify.error({ title: '请上传以前场景图片' });
                return false
            }
            if (!new_content) {
                this.$notify.error({ title: '请输入现在场景文字描述' });
                return false
            }
            if (!newImg.length) {
                this.$notify.error({ title: '请上传现在场景图片' });
                return false
            }
            this.scenarios_item.old_img = this.scenarios_item.oldImg.join();
            this.scenarios_item.new_img = this.scenarios_item.newImg.join();
            this.scenceList.push(this.scenarios_item)
            sessionStorage.setItem("scenceList", JSON.stringify(this.scenceList))
            this.$router.go(-1)
        }
    }
};
</script>
<style lang="less" scoped>
    .banner_wrap{
        .title_btn{
            margin: 0 0 20px 0;
        }
        .btn_wrap{
            margin-top: 50px;
            text-align: center;
        }
        .case_wrap{

            padding: 20px;
            border: 1px solid #ccc;
            .item{
               display: flex;
               align-items: center;
               margin-bottom: 40px;
            }
            .item:last-child{
                margin-bottom: 0;
            }
            .case_left{
                margin-right: 80px;
            }
            .case-item{
                display: flex;
                align-items: center;
                margin-right: 60px;
                /deep/ .add-box{
                    padding-left: 0;
                    margin-top: 0;
                    .add{
                        width: 100px;
                        height: 100px;
                    }
                }
                .label{
                    width: 80px;
                }
                .co_w{
                    width: 100px;
                }
                /deep/ .el-textarea{
                    width: 300px;
                }
                /deep/ .el-input{
                    width: 300px;
                }
                .alt-input{
                    margin-top: 20px;
                }
            }
        }
    }
</style>
